var map = {
	"./badge-app-store-bg.png": 66052,
	"./badge-app-store-cs.png": 70523,
	"./badge-app-store-hu.png": 25152,
	"./badge-app-store-ro.png": 93980,
	"./badge-app-store-sk.png": 17891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37675;